"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormDateTimeItem = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const formik_1 = require("formik");
const FormItemInput_1 = require("../FormItemInput");
const tech_1 = require("../../../../tech");
const FormDateTimeItem = ({ value, ...props }) => {
    const [field, meta, helpers] = (0, formik_1.useField)(props.name);
    const handleChange = (e) => {
        const dateVal = new Date(e.target.value);
        helpers.setValue(isNaN(dateVal.getTime()) ? undefined : dateVal, false);
    };
    const actualValue = value ?? field.value;
    const valueDate = actualValue ? (0, tech_1.dateToTimeString)(actualValue) : "";
    const readableValue = actualValue ? (0, tech_1.formattedDate)(actualValue) : undefined;
    // const handleChange  = (e: React.ChangeEvent<HTMLInputElement>) => {
    //     helpers.setValue(e.target.value);
    // }
    return ((0, jsx_runtime_1.jsx)(FormItemInput_1.FormItemInput, { ...props, type: "datetime-local", value: valueDate ?? "", onChange: handleChange, onBlur: field.onBlur }));
};
exports.FormDateTimeItem = FormDateTimeItem;
